import * as React from 'react';
import {Typography} from "@mui/material";
import {useDarkMode} from "../../darkMode/hook/useDarkMode";
import {usePoliceMode} from "../../policeMode/hook/usePoliceMode";

export default function ToolBoxButton({text, icon, action, iconSelected}) {
    const {mode} = useDarkMode();
    const {police} = usePoliceMode();

    return (
        <button
            className={'toolBoxButton'}
            onClick={() => action()}
            style={{backgroundColor: !mode.darkMode ? mode.settings.inputBackgroundColor : '#79A00B'}}
        >
            <img src={ !mode.darkMode ? icon : iconSelected} alt={text}/>
            <Typography
                variant={'subtitle5'}
                sx={{marginLeft:'4px'}}
                color={!mode.darkMode ? mode.settings.textColor3 : 'white'}
            >
                {text}
            </Typography>
        </button>
    )
}
